import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import NotFoundPage from "./pages/NotFoundPage";
import { fetchBranch } from "./redux/actions/branchActions";
import { fetchDropDown } from "./redux/actions/dropDownAction";
import { StoreState } from "./redux/reducers";
import { AppDispatch } from "./redux/store";
import Employee from "./pages/Employee";
import { fetchEmployeeAttendanceAction } from "./redux/actions/employeeAttendanceAction";
import EmployeeAttachment from "./pages/EmployeeAttachment";
import EmployeeSalaryPage from "./pages/EmployeeSalary";
import SalaryMasterPage from "./pages/SalesMaster";
import ProjectPage from "./pages/Project";
import HolidayPage from "./pages/Holiday";
import LeaveRequestPage from "./pages/LeaveRequest";
import SprintPage from "./pages/Sprint";
import ModulePage from "./pages/Module";
import SubModulePage from "./pages/SubModule";
import LeaveTransactionPage from "./pages/LeaveTransaction";
import TaskLogPage from "./pages/TaskLog";
import EmployeeReportPage from "./pages/EmployeeReport";
import TaskPage from "./pages/Task";
import ViewHolidayPage from "./pages/ViewHolidayPage";
import DropDown from "./pages/DropDown";
import SalaryMasterLogPage from "./pages/SalaryMasterLog";
import ForgotPasswordPage from "./pages/ForgotPassword";
import Pages from "./pages/Page";
import UserHolidayPage from "./pages/user/UserHoliday";
import EmployeeReportPageUser from "./pages/user/EmployeeReportUser";
import PaySlip from "./pages/user/PaySlip";
import EmployeeLeaveRequestPage from "./pages/user/EmployeeLeaveRequest";
import Attendance from "./pages/user/Attendance";
import AttendanceAdmin from "./pages/AttendanceAdmin";
import ProtectedRoute from "./components/ProductedRouter";
import RolePermissionPage from "./pages/RolePermission";

function App() {
  const dispatch = useDispatch<AppDispatch>();
  const authUser = useSelector((state: StoreState) => state.authUser);
  const [authInitialized, setAuthInitialized] = useState(false);

  // const AttendanceWrapper = () => {
  //   const attendanceList = useSelector(
  //     (state: StoreState) => state.employeeAttendance
  //   );

  //   return <Attendance attendanceList={attendanceList} />;
  // };
  // const authenticated = false;
  const authenticated =
    authUser?.token &&
    typeof authUser.token === "string" &&
    authUser.token !== undefined &&
    authUser.token !== "";

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedAuth = localStorage.getItem("authUser");

    if (token && storedAuth && !authenticated) {
      try {
        const parsedAuth = JSON.parse(storedAuth);
        dispatch({ type: "SET_AUTH_USER", payload: parsedAuth });
      } catch (error) {
        console.error("Failed to parse authUser:", error);
        localStorage.removeItem("token");
        localStorage.removeItem("authUser");
      }
    }
    setAuthInitialized(true);
  }, [dispatch, authenticated]);

  useEffect(() => {
    if (!authInitialized) return;
    if (authenticated) {
      dispatch(fetchEmployeeAttendanceAction()).catch((err) =>
        console.error("fetchEmployeeAttendance error:", err),
      );
    }
  }, [authenticated, dispatch, authInitialized]);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/forgot_password" element={<ForgotPasswordPage />} />
        <Route
          path="/employee"
          element={
            <ProtectedRoute>
              <Employee />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee_attachment/:id"
          element={
            <ProtectedRoute>
              <EmployeeAttachment />
            </ProtectedRoute>
          }
        />
        <Route
          path="/attendance"
          element={
            <ProtectedRoute>
              <Attendance />
            </ProtectedRoute>
          }
        />
        <Route
          path="/attendance_admin"
          element={
            <ProtectedRoute>
              <AttendanceAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee_salary"
          element={
            <ProtectedRoute>
              <EmployeeSalaryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/salary_master"
          element={
            <ProtectedRoute>
              <SalaryMasterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project"
          element={
            <ProtectedRoute>
              <ProjectPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/holiday"
          element={
            <ProtectedRoute>
              <HolidayPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/userHoliday"
          element={
            <ProtectedRoute>
              <UserHolidayPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/leave"
          element={
            <ProtectedRoute>
              <LeaveRequestPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sprint"
          element={
            <ProtectedRoute>
              <SprintPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/module"
          element={
            <ProtectedRoute>
              <ModulePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sub-module"
          element={
            <ProtectedRoute>
              <SubModulePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/leave_transaction"
          element={
            <ProtectedRoute>
              <LeaveTransactionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/task_management"
          element={
            <ProtectedRoute>
              <TaskLogPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee_report"
          element={
            <ProtectedRoute>
              <EmployeeReportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee_report_user"
          element={
            <ProtectedRoute>
              <EmployeeReportPageUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/task"
          element={
            <ProtectedRoute>
              <TaskPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/page"
          element={
            <ProtectedRoute>
              <Pages />
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-holiday"
          element={
            <ProtectedRoute>
              <ViewHolidayPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dropdown"
          element={
            <ProtectedRoute>
              <DropDown />
            </ProtectedRoute>
          }
        />
        <Route
          path="/salarymasterlog/:employeeId"
          element={
            <ProtectedRoute>
              <SalaryMasterLogPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payslip"
          element={
            <ProtectedRoute>
              <PaySlip />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<NotFoundPage />} />

        {/* Employee Routes */}
        <Route
          path="/employeeLeave"
          element={
            <ProtectedRoute>
              <EmployeeLeaveRequestPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/roles"
          element={
            <ProtectedRoute>
              <RolePermissionPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
